import React, { Component } from "react";
import DetailNameComponent from "../../components/detail/DetailNameComponent";
import DetailContentComponent from "../../components/detail/DetailContentComponent";
import { detailPpds } from "../../actions/member/ppds_action";
import { withRouter } from "react-router-dom";

import {
  getPpdsPending,
  getDetailPpds,
  getPpdsError,
} from "../../reducers/member/ppds_reducer";
import { connect } from "react-redux";

class DetailPPDS extends Component {
  constructor(props) {
    super(props);
    this.state = { selectedItem: "umum" };
  }

  render() {
    const { detailPpds_data } = this.props;
    let result = {
      name: null,
      npa_idi: null,
      email: null,
      address: null,
      place_of_birth: null,
      birthday: null,
      handphone: null,
    };
    if (detailPpds_data && detailPpds_data.data.length !== 0) {
      const data = detailPpds_data.data[0];
      result.name = data.name;
      result.npa_idi = data.npa_idi;
      result.email = data.email;
      result.address = data.address;
      result.place_of_birth = data.place_of_birth;
      result.birthday = data.birthday;
      result.handphone = data.handphone;
    }

    const {
      name,
      npa_idi,
      email,
      address,
      place_of_birth,
      birthday,
      handphone,
    } = result;

    return (
      <>
        <DetailNameComponent name="Informasi Umum" value={npa_idi} />
        <DetailContentComponent label="Nama Lengkap" value={name} />
        <DetailContentComponent label="NPA IDI/NIK" value={npa_idi} />
        <DetailContentComponent label="Email" value={email} />
        <DetailContentComponent label="Alamat" value={address} />
        <DetailContentComponent label="Tempat Lahir" value={place_of_birth} />
        <DetailContentComponent label="Tanggal Lahir" value={birthday} />
        <DetailContentComponent label="No Telepon" value={handphone} />
      </>
    );
  }
}

function mapStateToProps({ detailPpds }) {
  return {
    detailPpds_data: getDetailPpds(detailPpds),
    detailPpds_error: getPpdsError(detailPpds),
    detailPpds_pending: getPpdsPending(detailPpds),
  };
}

export default connect(mapStateToProps, { detailPpds })(withRouter(DetailPPDS));
